import { Box, Card, CardActions, CircularProgress, Container, CssBaseline, Paper, Stack, Typography, useTheme } from '@mui/material'
import React, { useContext, useState } from 'react'
import FilterStrip from '../../../../../../../components/FilterStrip'
import SingleLineChart from '../../../../../../../components/charts/SingleLineChart'
import EnergyReportingChart from '../../../../../../../components/charts/energy_reporting/EnergyReportingChart'
import{WEB_KEY,PASS_KEY} from "../../../../../../../api/AxiosApi"
import { InverterContext } from '../../../../../../../context/InverterContext'

import LineChart from '../../../../../../../components/charts/LineChart'
import { getDateTimeForDashboardTab1 } from '../../../../../../../utils'
import AppModal from '../../../../../../../components/AppModal'

function DailyPlant1Curve({SUB_PLANT}) {
    const { palette, breakpoints, spacing } = useTheme()
    const {InverterChartData2, InvChartLoading2, getInverterChartData2 } = useContext(InverterContext)
    let ChartLabel = []
    let datasetArr = []
    const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay)
    const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today)
    const LCODE = localStorage.getItem('LCODE')
    const LOGIN_ID=localStorage.getItem("LoginId")
    const TYP="A"

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    function onRefreshData() {
        if (StartDate.length !== 0 && EndDate.length !== 0) {
            getInverterChartData2(LOGIN_ID,LCODE,PASS_KEY,WEB_KEY,TYP,StartDate,EndDate,SUB_PLANT)
        } else {
            alert('please provide any date')
        }

    }

    function getRandomColor() {
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }
    let ChartData = new Object();
    if (InverterChartData2) {
        InverterChartData2.forEach((singleData, index) => {
            let ChartKey = Object.keys(InverterChartData2[0])
            ChartKey = ChartKey.filter(value => value.includes(' Day Total[KWH]'))
            ChartLabel.push(singleData.Date)
            for (let i = 0; i < ChartKey.length; i++)
                if (index == 0)
                    ChartData[ChartKey[i]] = [singleData[ChartKey[i]]]
                else
                    ChartData[ChartKey[i]].push(singleData[ChartKey[i]])
        });
        // preparing data

        for (let prop in ChartData) {
            datasetArr.push({
                label: prop.replace(" Day Total[KWH]", ""),
                data: ChartData[prop],
                borderColor: getRandomColor(),
                backgroundColor: getRandomColor(),
                tension: 0.3,
                borderWidth: 0.9,
                pointRadius: 1,
                pointHoverRadius: 1,
            })
        }
        // console.log('datasetArr', datasetArr)
        // setDatasetArray([...datasetArr])
    } else {
        console.log('data not set')

    }







    // const labels = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

    // const data = [{
    //     label: 'Energy',
    //     data: [65, 59, 80, 81, 56, 55, 40],
    //     fill: false,
    //     borderColor: 'rgb(75, 192, 192)',
    //     tension: 0.3,
    //     pointRadius: 7,
    //     pointHoverRadius: 1
    // }]
    return (
        <>
            <CssBaseline />
            <Box component={Stack} sx={{ bgcolor: 'background.default', rowGap: spacing(1), py: spacing(1) }}>
                <FilterStrip
                    title={'Daily Energy Curve'}
                    ValueOf1={StartDate}
                    ValueOf2={EndDate}
                    onChangeValueOf1={(val) => setStartDate(val.target.value)}
                    onChangeValueOf2={(val) => setEndDate(val.target.value)}
                    onFullScreen={handleOpen}
                    onRefreshData={onRefreshData}
                />
                {
                    InvChartLoading2 ? <Typography variant='body2' textAlign={'center'} color={'primary.main'}>Data Loading.........</Typography> :
                        datasetArr?.length == 0 ?
                            <Typography variant='body2' color={'error.main'} textAlign={"center"}>Data not found</Typography>
                            :
                            <>
                                <Card>
                                    <CardActions>
                                        <Container maxWidth={false}>
                                            <EnergyReportingChart data={datasetArr} labels={ChartLabel} />
                                        </Container>
                                    </CardActions>
                                </Card>
                                <AppModal
                                    open={open}
                                    handleClose={handleClose}
                                >
                                    <Box>
                                        <Typography variant='h5' textAlign={'center'}>Daily Energy Curve</Typography>
                                        <Container maxWidth={false}>
                                            <EnergyReportingChart data={datasetArr} labels={ChartLabel} />
                                        </Container>
                                    </Box>
                                </AppModal>
                            </>
                }

            </Box>
        </>
    )
}

export default DailyPlant1Curve
